import gql from 'graphql-tag';

export const USER_SETTINGS_QUERY = gql`
  query getCurrentUsersSettings {
    currentUserSettings: getCurrentUsersSettings
  }
`;

export interface UserSettingsQueryResponse {
  currentUserSettings: any;
}
